export class ElementStats {
  fields = [];
  data = [];
}
